import { render, staticRenderFns } from "./TickerWithScore.vue?vue&type=template&id=a4483f4e&scoped=true&"
import script from "./TickerWithScore.vue?vue&type=script&lang=js&"
export * from "./TickerWithScore.vue?vue&type=script&lang=js&"
import style0 from "./TickerWithScore.vue?vue&type=style&index=0&id=a4483f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4483f4e",
  null
  
)

export default component.exports